const NotFoundIcon = (props) => (
  <svg
    width={359}
    height={293}
    viewBox="0 0 359 293"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M156.394 242.331C156.426 239.769 156.328 236.216 155.719 232.044C155.206 228.53 153.555 217.307 147.635 208.825C138.689 196 128.548 201.717 118.154 188.461C112.201 180.874 113.877 176.897 107.078 170.83C101.068 165.463 94.619 163.486 87.7388 162.356C70.3434 159.493 41.9609 162.177 41.9609 162.177C44.36 189.681 53.6067 201.059 61.5847 206.361C72.7832 213.81 81.3955 209.248 91.3822 218.161C104.378 229.766 95.847 242.917 107.964 254.993C107.964 254.993 113.267 260.28 154.442 268.103L156.394 242.331Z"
      fill="#F5F5F5"
    />
    <path
      d="M154.434 268.103C154.434 268.103 122.627 213.973 110.518 203.368C98.4006 192.764 41.9609 162.177 41.9609 162.177"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.8021 185.257L47.2793 187.25"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.1465 189.657L92.5049 163.308"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.298 200.091L75.5488 211.452"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M119.301 213.599L123.261 193.625"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M129.231 227.75L99.4414 233.19"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M136.996 239.68L148.203 209.663"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M144.065 250.96L109.615 256.035"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M137.484 246.568C136.541 244.185 135.085 240.94 132.922 237.321C131.1 234.272 125.293 224.529 116.575 218.95C103.409 210.525 96.2197 219.682 81.5487 211.403C73.1478 206.67 73.1803 202.352 64.568 199.343C56.9641 196.683 50.2467 197.326 43.4641 198.903C26.2964 202.905 1.09375 216.234 1.09375 216.234C13.8211 240.737 26.7112 247.715 36.1123 249.569C49.3033 252.171 55.5247 244.665 68.1544 249.089C84.5984 254.847 81.7439 270.258 97.5535 276.788C97.5535 276.788 104.474 279.643 145.511 271.145L137.484 246.568Z"
      fill="#F5F5F5"
    />
    <path
      d="M145.527 271.136C145.527 271.136 95.4465 233.271 80.1981 228.099C64.9496 222.927 1.10938 216.234 1.10938 216.234"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.6681 221.959L15.6016 237.37"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.1268 223.212L48.2383 197.968"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.0426 226.684L50.9785 248.935"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.2268 234.19L88.25 214.225"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.808 243.478L81.3613 259.889"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M118.544 251.529L117.43 219.511"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M129.393 259.255L99.498 277.114"
      stroke="#D6D6D6"
      strokeWidth={0.4657}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M253.357 271.543H144.918L155.36 199.838H242.915L253.357 271.543Z"
      fill="#5E5BA0"
    />
    <path
      d="M333.966 212.485H64.3161C57.4686 212.485 51.9141 206.931 51.9141 200.083V30.2029C51.9141 23.3553 57.4686 17.8008 64.3161 17.8008H333.966C340.813 17.8008 346.368 23.3553 346.368 30.2029V200.075C346.368 206.93 340.813 212.485 333.966 212.485Z"
      fill="#3748C4"
    />
    <path
      d="M326.818 192.056H71.4568C64.6092 192.056 59.0547 186.501 59.0547 179.654V36.0661C59.0547 29.2186 64.6092 23.6641 71.4568 23.6641H326.818C333.665 23.6641 339.22 29.2186 339.22 36.0661V179.654C339.22 186.501 333.665 192.056 326.818 192.056Z"
      fill="#F5F5F5"
    />
    <path
      d="M276.339 276.764H121.936V269.306C121.936 263.54 126.612 258.864 132.378 258.864H265.897C271.663 258.864 276.339 263.54 276.339 269.306V276.764Z"
      fill="#3748C4"
    />
    <path
      d="M68.1875 192.056H324.907"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M128.732 273.039V269.119C128.732 266.753 130.652 264.833 133.018 264.833H248.817"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M236.514 218.21L240.621 249.545"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.551 208.914C199.87 208.914 202.561 206.224 202.561 202.904C202.561 199.585 199.87 196.895 196.551 196.895C193.232 196.895 190.541 199.585 190.541 202.904C190.541 206.224 193.232 208.914 196.551 208.914Z"
      fill="white"
    />
    <path
      d="M282.016 35.0898H313.903C319.978 35.0898 324.906 40.0182 324.906 46.0931V112.349"
      stroke="white"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M306.354 56.0804C308.192 51.6482 310.014 48.2244 311.819 45.8009C313.616 43.3774 315.967 41.4419 318.854 40.0024C320.545 39.116 322.302 38.4898 324.14 38.0994C325.97 37.7172 327.718 37.2293 329.369 36.6437C331.02 36.0582 332.541 35.253 333.931 34.2446C335.322 33.2362 336.469 31.6422 337.371 29.4627C338.9 25.7868 338.957 22.7859 337.534 20.4844C336.111 18.1748 334.013 16.4425 331.239 15.2877C327.254 13.6287 324.058 13.6043 321.635 15.1901C319.211 16.7841 317.032 19.3784 315.096 22.973L300.564 16.9305C302.093 13.2546 304.085 10.1561 306.533 7.6513C308.981 5.14649 311.754 3.3004 314.844 2.12119C317.935 0.941975 321.269 0.42963 324.855 0.600413C328.442 0.771196 332.11 1.63324 335.867 3.19468C343.975 6.56967 349.692 10.8799 353.018 16.1335C356.336 21.3871 356.45 27.7386 353.36 35.1717C352.36 37.5789 351.245 39.5795 350.001 41.1735C348.765 42.7756 347.35 44.1012 345.764 45.1584C344.178 46.2157 342.405 47.0859 340.454 47.769C338.494 48.4521 336.33 49.0946 333.972 49.6964C331.784 50.2901 329.963 50.9163 328.499 51.5831C327.035 52.25 325.783 53.0795 324.758 54.0554C323.733 55.0395 322.871 56.1536 322.172 57.406C321.472 58.6584 320.781 60.1141 320.098 61.765L306.354 56.0804ZM296.863 77.6397L302.995 62.8792L318.203 69.1982L312.071 83.9587L296.863 77.6397Z"
      fill="#8A3A85"
    />
    <path
      d="M217.728 78.2334V66.181C217.728 62.2286 214.524 59.0244 210.572 59.0244H140.608C136.655 59.0244 133.451 62.2286 133.451 66.181V78.2334V158.526C133.451 162.478 136.655 165.682 140.608 165.682H252.487C256.439 165.682 259.643 162.478 259.643 158.526V85.39C259.643 81.4376 256.439 78.2334 252.487 78.2334H217.728Z"
      fill="#F5F5F5"
    />
    <path
      d="M210.645 95.0674L196.551 109.161L182.458 95.0674L173.951 103.574L188.045 117.668L173.951 131.761L182.458 140.268L196.551 126.174L210.645 140.268L219.152 131.761L205.058 117.668L219.152 103.574L210.645 95.0674Z"
      fill="#D6D6D6"
    />
    <path
      d="M43.8309 276.073V266.793H26.7363V292.313L65.3251 292.931V288.288L43.8309 276.073Z"
      fill="#F7A99C"
    />
    <path
      d="M66.6892 292.932V290.728C66.6892 288.475 65.453 286.409 63.4768 285.344L47.2037 276.561C42.3242 277.895 38.5588 277.708 35.9808 277.268C31.7031 276.545 27.6124 274.601 26.238 276.227C25.8477 276.691 25.7989 277.301 25.8152 277.724V291.216C25.8152 292.159 26.5796 292.932 27.5311 292.932H66.6892Z"
      fill="#FFC001"
    />
    <path
      d="M66.6907 291.459H25.8086"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.6798 282.4L55.3945 285.425"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.004 281.456L53.7188 284.481"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.2563 280.578L51.9629 283.603"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.67 278.976C48.8968 280.033 44.3182 281.391 38.5441 281.359C32.9733 281.326 28.5411 280.017 25.8086 278.976"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.5454 276.073V266.793H75.459V292.313L114.048 292.931V288.288L92.5454 276.073Z"
      fill="#F7A99C"
    />
    <path
      d="M115.412 292.932V290.728C115.412 288.475 114.176 286.409 112.199 285.344L95.9263 276.561C91.0468 277.895 87.2815 277.708 84.7035 277.268C80.4257 276.545 76.3351 274.601 74.9607 276.227C74.5703 276.691 74.5215 277.301 74.5378 277.724V291.216C74.5378 292.159 75.3023 292.932 76.2538 292.932H115.412Z"
      fill="#FFC001"
    />
    <path
      d="M115.413 291.459H74.5312"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.403 282.4L104.109 285.425"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M104.727 281.456L102.434 284.481"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M102.971 280.578L100.686 283.603"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M100.393 278.976C97.6195 280.033 93.0408 281.391 87.2668 281.359C81.696 281.326 77.2638 280.017 74.5312 278.976"
      stroke="#3897E9"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.728 143.911C82.728 143.911 96.8054 188.607 98.9687 194.796C101.132 200.985 103.141 209.646 102.677 217.226C102.214 224.805 94.9431 271.51 94.9431 271.51H73.7579C73.7579 271.51 72.2615 222.17 71.5377 218.307C70.8139 214.444 64.6332 192.568 64.6332 192.568C64.6332 192.568 62.6245 218.153 60.9248 224.951C59.2251 231.758 45.6113 272.275 45.6113 272.275H25.8086L34.1607 143.903H82.728V143.911Z"
      fill="#3897E9"
    />
    <path
      d="M115.021 116.667C115.021 116.667 121.739 110.966 123.439 107.234C124.894 104.046 126.927 98.4342 127.489 96.8809C127.57 96.6451 127.814 96.515 128.058 96.5719L128.465 96.6695C129.709 96.9622 130.481 98.2147 130.18 99.4589L129.505 102.257L136.605 97.5966C137.215 97.1981 138.037 97.3933 138.394 98.0276C138.712 98.5888 138.557 99.2963 138.045 99.6704L133.36 103.086L141.143 99.4345C141.745 99.1499 142.461 99.3776 142.794 99.955L142.802 99.9713C143.152 100.581 142.94 101.362 142.322 101.712L142.412 101.687C143.087 101.492 143.802 101.817 144.095 102.46C144.437 103.2 144.087 104.07 143.339 104.379L142.843 104.582C143.485 104.379 144.168 104.786 144.299 105.444C144.494 106.412 144.022 107.388 143.152 107.844C141.062 108.933 139.696 109.218 137.711 110.706C136.133 111.885 136.687 112.634 135.011 114.789C132.962 117.407 131.221 117.481 127.7 120.075C126.358 121.059 124.512 122.596 122.56 124.873L115.021 116.667Z"
      fill="#F7A99C"
    />
    <path
      d="M138.517 98.3125C138.517 98.3125 138.875 99.0363 138.2 99.5486C137.525 100.061 132.23 103.981 132.23 103.981"
      stroke="#262626"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M142.33 101.72L135.043 105.103"
      stroke="#262626"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M143.079 104.542L135.76 107.909"
      stroke="#262626"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M128.978 96.8647C128.978 96.8647 130.255 97.678 130.222 98.5726C130.19 99.4672 128.896 105.241 128.896 105.241"
      stroke="#262626"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.7576 271.51C73.7576 271.51 71.8383 220.926 71.692 219.617C71.5456 218.307 64.332 191.535 64.332 191.535L65.6088 179.702C65.6088 179.702 80.1579 215.51 80.1579 217.868C80.1579 220.226 81.7763 271.518 81.7763 271.518H73.7576V271.51Z"
      fill="#1775AF"
    />
    <path
      d="M61.7461 221.861L66.9102 165.958"
      stroke="#262626"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.7571 267.216H73.5879L73.7587 271.51H94.9439L95.7571 267.216Z"
      fill="#262626"
    />
    <path
      d="M46.8881 268.444H26.0607L25.8086 272.283H45.6031L46.8881 268.444Z"
      fill="#262626"
    />
    <path
      d="M97.0488 199.22C99.8545 208.052 100.302 217.616 98.3256 226.667"
      stroke="white"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M120.609 110.657C120.609 110.657 117.023 113.422 112.932 114.138C108.142 114.976 103.986 112.145 102.872 111.381C99.8388 109.307 98.7165 106.851 96.7078 103.972C90.7629 95.4576 87.0626 90.1714 81.8903 87.1705C79.2147 85.6253 74.75 83.8769 67.6991 84.4136C66.1214 83.8443 63.6003 84.2997 61.9087 84.2997C60.5018 84.2997 59.103 84.2997 57.6961 84.2997C54.9311 84.6332 34.551 86.9997 31.0865 83.8199C29.7203 82.5675 29.6959 81.3314 29.6959 81.3314C29.6796 80.3067 30.3221 79.2494 32.0136 77.9645C36.1368 74.8254 43.7082 72.4751 46.2455 71.7269L44.7004 60.1787C44.7004 60.1787 44.7004 60.1787 41.301 60.1787C37.9016 60.1787 25.8329 62.1874 19.3432 64.4564C10.2348 67.6362 5.35526 69.9621 2.94803 75.2401C-0.0691292 81.8519 3.14321 88.9597 3.98086 90.8058C8.16097 100.052 17.432 103.802 23.0353 106.062C27.9718 108.055 32.3715 108.86 35.4293 109.21L32.8025 151.279L81.1584 153.906H88.4207C88.9737 147.481 86.1924 127.508 86.5584 120.986C92.731 129.573 102.962 133.916 112.664 132.054C123.407 129.988 128.815 121.221 129.693 119.749C125.936 112.333 120.609 110.657 120.609 110.657Z"
      fill="#FEC02D"
    />
    <path
      d="M60.5339 107.607H60.0703V87.5283H63.12V105.029C63.1119 106.453 61.9571 107.607 60.5339 107.607Z"
      fill="white"
    />
    <path
      d="M88.4864 151.678C86.8192 151.987 63.9343 155.826 47.7587 138.747C34.1124 124.337 35.7226 106.103 36.0073 103.412C35.1615 116.058 34.3076 128.704 33.4618 141.358H33.413L32.7949 151.271L40.3744 151.686L40.3663 151.629C51.6705 152.524 63.3406 153.191 75.3442 153.581C79.7439 153.727 84.0948 153.833 88.405 153.898C88.4376 153.158 88.462 152.418 88.4864 151.678Z"
      fill="#FEC02D"
    />
    <path
      d="M75.6673 69.1006C76.4968 64.8473 76.3667 61.5211 76.1227 59.3985C75.9438 57.7802 75.6591 56.5603 74.7971 55.3973C74.6182 55.1534 73.1868 53.2748 70.739 52.7868C67.8113 52.2013 67.0712 54.3238 62.9073 54.8443C59.3128 55.2916 58.6052 53.8603 56.1899 54.885C53.555 56.0073 52.2456 58.6178 51.8553 59.4067C51.6845 59.7564 50.8224 61.5211 50.733 64.0097C50.6679 65.9777 51.1152 67.4579 51.2941 68.0597C52.0423 70.6051 52.9206 74.4762 54.0022 80.6732C54.5634 80.6488 55.1245 80.6325 55.6857 80.6081C62.3543 76.7696 69.0067 72.9392 75.6673 69.1006Z"
      fill="#262626"
    />
    <path
      d="M61.4281 90.0256C58.2808 90.0337 55.7272 87.4964 55.7109 84.3491L55.6621 72.0934L67.0558 72.0527L67.1046 84.3084C67.1127 87.4476 64.5753 90.0093 61.4281 90.0256Z"
      fill="#F7A99C"
    />
    <path
      d="M67.0887 80.8762L59.6719 77.062C59.7451 77.7045 60.168 80.7135 62.811 82.7873C64.5026 84.1129 66.2755 84.4138 67.0969 84.5033L67.0887 80.8762Z"
      fill="#FF7769"
    />
    <path
      d="M55.3863 68.2951C55.3538 68.1081 54.8658 67.8316 54.7113 67.734C54.4592 67.5713 54.1827 67.4412 53.8981 67.3518C53.345 67.1728 52.7351 67.1322 52.1577 67.2623C51.0191 67.5225 50.0188 68.474 49.8237 69.6451C49.7098 70.3201 49.8725 71.0276 50.1652 71.6457C50.6044 72.581 51.3444 73.3698 52.239 73.8822C52.9791 74.3132 53.8249 74.549 54.6788 74.606C54.8496 74.6141 56.598 74.5734 56.5899 74.5084C56.1914 72.4427 55.7929 70.3689 55.3863 68.2951Z"
      fill="#F7A99C"
    />
    <path
      d="M53.8252 68.4171C53.9635 69.328 54.7605 74.1505 59.1114 77.5662C59.9084 78.1924 65.2352 82.3644 70.1065 80.3312C76.3686 77.7126 75.6854 67.4331 75.6366 66.8801C75.4903 65.0015 75.0511 59.4551 70.4562 56.4949C66.7071 54.0795 62.649 54.9659 62.0716 55.1042C61.4617 55.2506 57.5987 56.2184 55.2322 60.0081C53.0933 63.44 53.6057 66.9207 53.8252 68.4171Z"
      fill="#F7A99C"
    />
    <path
      d="M72.0914 66.8719C72.189 67.6771 72.8152 68.2545 73.4739 68.1732C74.1327 68.0918 74.5881 67.368 74.4905 66.571C74.3929 65.7659 73.7748 65.1885 73.108 65.2698C72.4411 65.3512 71.9857 66.075 72.0914 66.8719Z"
      fill="#262626"
    />
    <path
      d="M64.8511 67.7831C64.9486 68.5882 65.5667 69.1656 66.2336 69.0843C66.8923 69.0029 67.3477 68.2792 67.2501 67.4822C67.1526 66.6771 66.5264 66.0996 65.8676 66.181C65.2089 66.2623 64.7535 66.978 64.8511 67.7831Z"
      fill="#262626"
    />
    <path
      d="M69.9033 68.0757L71.0093 69.5721C71.2126 69.8486 71.1394 70.2389 70.8466 70.4178L69.8301 71.0359"
      stroke="#262626"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.4291 71.5645C62.5429 72.4672 63.3643 73.1016 64.267 72.9877C65.1698 72.8739 65.8041 72.0525 65.6902 71.1498C65.5764 70.2471 64.755 69.6127 63.8523 69.7266C62.9577 69.8404 62.3152 70.6618 62.4291 71.5645Z"
      fill="#FF7769"
    />
    <path
      d="M54.6224 72.4101C54.6305 72.2311 54.6468 71.0031 53.6628 70.1248C52.8902 69.4336 52.0037 69.3848 51.7598 69.3848"
      stroke="#262626"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.7589 70.3692C53.702 70.3611 53.0432 70.2717 52.5878 70.7677C52.2137 71.1744 52.2462 71.6786 52.2544 71.768"
      stroke="#262626"
      strokeWidth={0.733}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.6783 67.2951C53.6783 67.2951 54.4916 67.3683 55.1015 67.9701C55.7115 68.5719 55.931 69.6129 55.931 69.6129C57.4925 69.4258 61.0626 68.7671 64.2994 65.9533C66.056 64.4325 67.1295 62.7816 67.7557 61.5942C68.3494 62.1228 69.3578 62.9198 70.781 63.5379C72.6433 64.343 74.9611 64.7253 75.2701 64.0991C75.3271 63.9852 75.262 63.6518 75.14 62.9768C75.0912 62.7328 75.0424 62.375 74.9286 62.0334C74.7009 61.3584 74.4 60.7159 74.0421 60.0979C73.3265 58.8698 72.375 57.7801 71.2527 56.9018C70.5208 56.3325 69.7238 55.8608 68.878 55.4949C66.178 54.3482 62.4289 54.3482 59.2003 56.0641C59.2003 56.0641 55.5976 57.9834 54.0118 61.7488C53.4669 63.0418 53.3286 64.3349 53.2961 64.7822C53.231 65.6686 53.3286 66.246 53.4587 66.6933C53.5319 66.9536 53.6214 67.1569 53.6783 67.2951Z"
      fill="#262626"
    />
    <path
      d="M74.7899 68.9617C75.099 68.9211 75.3999 68.978 75.6682 69.1C75.6357 69.9783 75.5544 71.0518 75.3592 72.1904C75.3104 72.1985 75.2535 72.2229 75.2047 72.2229C74.302 72.3367 73.4806 71.6943 73.3667 70.7997C73.2529 69.9051 73.8872 69.0756 74.7899 68.9617Z"
      fill="#FF7769"
    />
    <path
      d="M62.7295 55.2996C62.1927 55.0882 61.412 54.8035 60.4442 54.527C58.3298 53.9171 57.2725 53.6162 56.3048 53.7382C53.4828 54.1041 51.8644 57.8126 51.1894 59.374C50.6771 60.5532 49.8313 62.5538 50.2786 65.0586C50.4738 66.1728 50.8723 67.0511 51.1813 67.6204"
      stroke="#262626"
      strokeWidth={0.25}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.7285 54.9661C63.68 54.5514 64.7047 54.2098 65.6156 53.7381C66.5833 53.2339 67.421 52.5833 68.4538 52.2011C69.5354 51.7944 70.7472 51.6318 71.8532 51.9734C72.8047 52.2661 73.6261 52.9005 74.293 53.6324C75.1957 54.6245 75.8869 55.82 76.2529 57.1131C76.9441 59.6098 76.3261 62.2041 75.9195 64.6926"
      stroke="#262626"
      strokeWidth={0.25}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.1311 74.4678C71.1311 75.281 70.3422 75.9316 69.3663 75.9316C68.3904 75.9316 67.6016 75.2729 67.6016 74.4678C67.6016 73.6626 68.3904 73.0039 69.3663 73.0039C70.3422 73.0039 71.1311 73.6626 71.1311 74.4678Z"
      fill="white"
    />
    <path
      d="M44.9766 62.1553L48.2296 60.1709C48.2296 60.1709 48.8964 57.3083 49.7991 56.6984C50.7019 56.0884 55.5082 54.2261 55.5082 54.2261L56.2076 54.8767C56.2076 54.8767 52.4503 58.3086 51.6696 59.8294C50.8889 61.3502 50.7425 65.5953 50.7425 65.5953L47.0666 70.3447L46.1639 71.0278L44.9766 62.1553Z"
      fill="#F7A99C"
    />
    <path
      d="M36.0145 105.241L34.3066 127.223"
      stroke="#262626"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.7129 107.039L87.0222 131.29"
      stroke="#262626"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5931 72.4102C9.90992 72.955 6.39668 75.8583 5.8274 80.9981C5.20933 86.5933 8.57619 90.4318 9.1048 91.0092"
      stroke="white"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M94.1387 122.587C95.0414 123.596 98.5628 127.255 104.467 128.052C110.07 128.809 114.25 126.507 115.454 125.783"
      stroke="white"
      strokeWidth={0.4147}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M247.776 141.845L255.315 137.812L266.506 139.861L272.101 133.892L285.34 137.438L292.709 127.37L305.859 135.429L301.386 106.998L284.031 94.8477L244.141 101.126C242.645 101.362 241.628 102.761 241.864 104.257L247.776 141.845Z"
      fill="#F5F5F5"
    />
    <path
      d="M288.081 109.096L301.386 107.005L284.031 94.8555L286.04 107.615C286.194 108.583 287.105 109.25 288.081 109.096Z"
      fill="#D6D6D6"
    />
    <path
      d="M284.031 94.8477L286.04 107.608C286.194 108.583 287.113 109.25 288.089 109.096L301.394 107.006"
      stroke="#262626"
      strokeWidth={0.274}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M253.153 179.182C253.389 180.678 254.788 181.695 256.284 181.459L308.543 173.237C310.04 173.001 311.056 171.602 310.821 170.106L305.86 138.609L292.709 130.549L285.341 140.617L272.102 137.072L266.507 143.041L255.316 140.991L247.777 145.025L253.153 179.182Z"
      fill="#F5F5F5"
    />
    <path
      d="M247.784 141.845L255.323 137.812L266.513 139.861L272.109 133.892L285.348 137.438L292.716 127.37L305.867 135.429L301.394 106.998L284.039 94.8477L244.149 101.126C242.653 101.362 241.636 102.761 241.872 104.257L247.784 141.845Z"
      stroke="#262626"
      strokeWidth={0.274}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M253.161 179.182C253.397 180.678 254.795 181.695 256.292 181.459L308.551 173.237C310.048 173.001 311.064 171.602 310.828 170.106L305.868 138.609L292.717 130.549L285.349 140.617L272.109 137.072L266.514 143.041L255.324 140.991L247.785 145.025L253.161 179.182Z"
      stroke="#262626"
      strokeWidth={0.274}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.6185 53.4126L44.301 54.665L32.6309 44.1334L35.9896 40.9292L45.6185 53.4126Z"
      fill="#FF7129"
    />
    <path
      d="M48.5075 51.2496L46.7102 51.583L42.709 36.3834L47.2713 35.5376L48.5075 51.2496Z"
      fill="#FF7129"
    />
    <path
      d="M42.2865 56.2754L42.1401 58.097L26.4199 57.9751L26.794 53.3477L42.2865 56.2754Z"
      fill="#FF7129"
    />
    <path
      d="M230.107 286.783C226.162 282.904 226.105 276.569 229.985 272.624L276.088 225.708L290.368 239.745L244.265 286.661C240.394 290.605 234.051 290.662 230.107 286.783Z"
      fill="#5E5BA0"
    />
    <path
      opacity={0.2}
      d="M312.361 243.673C334.724 243.623 352.812 225.453 352.761 203.09C352.71 180.727 334.54 162.639 312.177 162.69C289.814 162.741 271.727 180.911 271.777 203.274C271.828 225.637 289.998 243.724 312.361 243.673Z"
      fill="#DCF0FF"
    />
    <path
      opacity={0.5}
      d="M274.381 217.453C275.747 221.089 277.65 224.561 280.09 227.749L352.754 202.62C352.697 198.692 352.071 194.772 350.883 190.99L274.381 217.453Z"
      fill="white"
    />
    <path
      opacity={0.5}
      d="M271.875 205.856C272.03 208.15 272.371 210.435 272.916 212.688L349.093 186.338C348.142 184.265 347.011 182.248 345.694 180.32L271.875 205.856Z"
      fill="white"
    />
    <path
      d="M345.028 169.846C326.624 151.759 297.03 152.011 278.943 170.423C260.856 188.827 261.108 218.421 279.52 236.508C297.924 254.595 327.519 254.343 345.605 235.931C363.692 217.527 363.432 187.941 345.028 169.846ZM285.295 230.628C270.136 215.73 269.924 191.365 284.823 176.206C299.722 161.047 324.087 160.835 339.246 175.734C354.405 190.633 354.616 214.998 339.717 230.157C324.819 245.316 300.454 245.527 285.295 230.628Z"
      fill="#5E5BA0"
    />
    <path
      d="M279.325 244.063L242.867 281.156"
      stroke="white"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M315.62 159.802C304.137 158.647 292.223 162.608 283.724 170.423C275.226 178.238 270.273 189.77 270.46 201.31"
      stroke="white"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NotFoundIcon;
